import React from 'react'
import parse from 'html-react-parser'
import { ArrowDownS, ArrowUpS } from 'icons'
import { TableContainer, ToggleTableButton } from './styles'
import type { CustomTableProps } from './types'
import { useCustomTable } from './useCustomTable'

const CustomTable: React.FC<CustomTableProps> = ({ html, title }) => {
  const { open, toggleTableButtonAction, toggleTableButtonLabel } = useCustomTable({ title })

  if (!html) return null

  return (
    <>
      <ToggleTableButton onClick={toggleTableButtonAction} endIcon={open ? <ArrowUpS /> : <ArrowDownS />}>
        {toggleTableButtonLabel}
      </ToggleTableButton>
      {open ? <TableContainer>{parse(html)}</TableContainer> : null}
    </>
  )
}

export default CustomTable
